/* pv-loading-lifecycle.js — s463 FIX-5a v3 (Codex r2 全修入).
 * 收口两族 skeleton shimmer + .media-loading:after halo-animateloader 永动.
 *   图片族 = .media--loading-effect ; AJAX 骨架族 = product-card-loading 的精确 .animated-loading 子集.
 * AJAX 族 = PER-OWNER 生命周期 (r2 B1): owner = [data-product-block] / [data-product-tab-block]
 *   (theme.js:322/1085), 其 beforeSend 给 owner 加 .ajax-loaded (theme.js:260/1106) 后 jQuery 派发
 *   ajaxSend → 本脚本按"刚获得 .ajax-loaded 且含未完成骨架、未被占用"的 owner 关联该 xhr, beginLoading
 *   其骨架; 该 xhr 的 ajaxComplete (success 残留 / error / abort 都 fire) → finishLoading 同 owner 骨架.
 *   已删除全局 refcount / window.load→finish-all / ajaxStop→finish-all (r2 B1 病灶). 首屏外 owner 的
 *   请求滚入才发 → 骨架在 load 时不被 finish (IO offscreen 停, 不可见), 滚入 in-flight shimmer, 其
 *   complete 才停. 从不发请求的 owner 靠 IO offscreen 停 (不可见=0 burn), near-viewport 才 shimmer.
 * 图片族 (r2 M2): tag 容器一次 + 每个 IMG 单独收口 — document capture-phase load/error (含 src/srcset
 *   替换的二轮) + attr-MO 监听 src/srcset 变化重开; lazysizes 'lazyloaded' scoped 到 IMG_SEL, 不写 .ajax-loaded (M3).
 * IntersectionObserver 三态 (B4): offscreen=停/不可见 / near=开 / loaded·error=永久停.
 * 纯客户端只读, 0 网络行为. */
(function () {
  'use strict';
  var SKEL = 'pv-skel';
  var STOP = 'pv-skel--stop';
  var DONE = 'data-pv-done';
  var IMG_SEL = '.media--loading-effect';
  var AJAX_SEL = '.card-media.animated-loading, .card-eyebrow > .animated-loading, ' +
    '.card-action .animated-loading, .card-action__skeleton, ' +
    '.card-information__group.animated-loading, .card-title.animated-loading, ' +
    '.card-price.animated-loading, .card-vendor.animated-loading';
  var OWNER_SEL = '[data-product-block], [data-product-tab-block]';
  var OWNER_LOADING = '[data-product-block].ajax-loaded, [data-product-tab-block].ajax-loaded';
  var jq = window.jQuery || null;

  function isDone(el) { return el.getAttribute && el.getAttribute(DONE) === '1'; }
  function activate(el) { if (el && el.classList && !isDone(el)) el.classList.remove(STOP); }      // IO resume
  function stopTemp(el) { if (el && el.classList && !isDone(el)) el.classList.add(STOP); }          // IO offscreen
  function finishLoading(el) {                                                                       // M1 terminal
    if (!el || !el.classList) return;
    el.setAttribute(DONE, '1'); el.classList.add(STOP);
    if (io) { try { io.unobserve(el); } catch (e) {} }
  }
  function beginLoading(el) {                                                                        // M1 re-open
    if (!el || !el.classList) return;
    el.removeAttribute(DONE); el.classList.remove(STOP);
    if (io) { try { io.observe(el); } catch (e) {} }
  }
  function tag(el, kind) {
    if (!el || !el.classList || el.classList.contains(SKEL)) return false;
    el.classList.add(SKEL); el.setAttribute('data-pv-skel', kind); return true;
  }
  function imgLoaded(img) {
    if (!img) return false;
    if (img.classList && img.classList.contains('lazyloaded')) return true;
    return !!(img.complete && img.naturalWidth > 0);
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (ents) {
    for (var i = 0; i < ents.length; i++) {
      var en = ents[i], el = en.target;
      if (isDone(el)) continue;
      if (en.isIntersecting) {
        if (el.getAttribute('data-pv-skel') === 'img') {
          var im = el.querySelector('img');
          if (im && imgLoaded(im)) { finishLoading(el); continue; }
        }
        activate(el);
      } else {
        stopTemp(el);
      }
    }
  }, { rootMargin: '200px 0px' }) : null;

  // ---- image family (r2 M2): tag container once, wire each IMG, handle src/srcset swap ----
  var attrMO = ('MutationObserver' in window) ? new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var im = ms[i].target;
      if (!im || im.tagName !== 'IMG' || !im.closest) continue;
      var c = im.closest(IMG_SEL);
      if (c && c.classList.contains(SKEL) && isDone(c) && !imgLoaded(im)) beginLoading(c);   // same-IMG src change -> new cycle
    }
  }) : null;
  function observeImgAttrs(img) { if (attrMO && img) { try { attrMO.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] }); } catch (e) {} } }
  function registerImg(el) {
    var imgs = el.getElementsByTagName ? el.getElementsByTagName('img') : [];
    if (!tag(el, 'img')) { for (var k = 0; k < imgs.length; k++) observeImgAttrs(imgs[k]); return; }  // already tagged: re-wire imgs
    for (var j = 0; j < imgs.length; j++) observeImgAttrs(imgs[j]);
    var loaded = false;
    for (var q = 0; q < imgs.length; q++) { if (imgLoaded(imgs[q])) { loaded = true; break; } }
    if (loaded) { finishLoading(el); return; }
    if (io) io.observe(el); else activate(el);
  }
  function onImgSettled(e) {   // capture-phase: any IMG load/error (incl re-load / src swap) -> finish its container
    var im = e.target;
    if (!im || im.tagName !== 'IMG' || !im.closest) return;
    var c = im.closest(IMG_SEL);
    if (c && c.classList.contains(SKEL)) finishLoading(c);
  }
  document.addEventListener('load', onImgSettled, true);
  document.addEventListener('error', onImgSettled, true);
  document.addEventListener('lazyloaded', function (e) {   // M3: scoped to IMG family, no .ajax-loaded mirror
    var t = e && e.target;
    if (!t || !t.closest) return;
    var c = t.closest(IMG_SEL);
    if (c) finishLoading(c);
  }, true);

  // ---- AJAX family (r2 B1): PER-OWNER lifecycle via jQuery ajaxSend/ajaxComplete ----
  function ajaxSkelsIn(owner) { return owner.querySelectorAll('.' + SKEL + '[data-pv-skel="ajax"]'); }
  function registerAjax(el) { if (!tag(el, 'ajax')) return; if (io) io.observe(el); else activate(el); }
  var ownerByXhr = (typeof WeakMap !== 'undefined') ? new WeakMap() : null;
  var xhrList = [];                 // fallback when no WeakMap
  var inflightOwners = [];          // owners currently mapped to an in-flight xhr
  function mapSet(x, o) { if (ownerByXhr) ownerByXhr.set(x, o); else xhrList.push({ x: x, o: o }); inflightOwners.push(o); }
  function mapGet(x) { if (ownerByXhr) return ownerByXhr.get(x); for (var i = 0; i < xhrList.length; i++) if (xhrList[i].x === x) return xhrList[i].o; return null; }
  function mapDel(x, o) { if (ownerByXhr) ownerByXhr.delete(x); else { for (var i = 0; i < xhrList.length; i++) if (xhrList[i].x === x) { xhrList.splice(i, 1); break; } } var j = inflightOwners.indexOf(o); if (j >= 0) inflightOwners.splice(j, 1); }
  function pickOwner() {
    // owner = an .ajax-loaded product-block/tab root that contains an unfinished ajax skeleton and is
    // not already mapped to an in-flight request. beforeSend added .ajax-loaded synchronously just
    // before this ajaxSend, so THIS request's owner is the unmapped one (concurrency-safe, FIFO).
    var cands = document.querySelectorAll(OWNER_LOADING);
    for (var i = 0; i < cands.length; i++) {
      var o = cands[i];
      if (inflightOwners.indexOf(o) >= 0) continue;
      if (o.querySelector('.' + SKEL + '[data-pv-skel="ajax"]:not([data-pv-done="1"])')) return o;
    }
    return null;
  }
  if (jq) {
    jq(document).on('ajaxSend.pvskel', function (e, xhr) {
      var owner = pickOwner();
      if (!owner) return;
      mapSet(xhr, owner);
      var sk = ajaxSkelsIn(owner);
      for (var i = 0; i < sk.length; i++) beginLoading(sk[i]);          // per-owner START + re-open (M1)
    });
    jq(document).on('ajaxComplete.pvskel', function (e, xhr) {
      var owner = mapGet(xhr);
      if (!owner) return;
      mapDel(xhr, owner);
      var sk = ajaxSkelsIn(owner);
      for (var i = 0; i < sk.length; i++) finishLoading(sk[i]);          // per-owner TERMINAL (success残留/error/abort)
    });
    // NO ajaxStop -> finish-all (r2 B1 removed)
  }

  function scan(root) {
    root = root || document;
    if (root.nodeType === 1) {
      if (root.matches && root.matches(IMG_SEL)) registerImg(root);
      else if (root.matches && root.matches(AJAX_SEL)) registerAjax(root);
    }
    if (!root.querySelectorAll) return;
    var a = root.querySelectorAll(IMG_SEL);
    for (var i = 0; i < a.length; i++) registerImg(a[i]);
    var b = root.querySelectorAll(AJAX_SEL);
    for (var j = 0; j < b.length; j++) registerAjax(b[j]);
  }
  var mo = ('MutationObserver' in window) ? new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var ad = ms[i].addedNodes;
      for (var j = 0; j < ad.length; j++) {
        var n = ad[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG' && n.closest) {   // new IMG into an image container: wire + maybe re-open (M2)
          var c = n.closest(IMG_SEL);
          if (c) {
            observeImgAttrs(n);
            if (c.classList.contains(SKEL) && isDone(c)) {
              var ii = c.getElementsByTagName('img'), any = false;
              for (var q = 0; q < ii.length; q++) { if (imgLoaded(ii[q])) { any = true; break; } }
              if (!any) beginLoading(c);
            }
          }
        }
        scan(n);
      }
    }
  }) : null;

  function boot() {
    scan(document);
    if (mo) mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // NO window.load -> finish-all (r2 B1). pageshow (bfcache) only re-scans/registers, never finish-all.
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) scan(document); });
})();
